<div class="reservacion-card ">
  <div class="divisa-row my-1">
    <span class="subtitulo text-color-primary divisa-col-12">{{ reservacion.order }}</span>
  </div>
  <div class="divisa-row my-1">
    <div class="divisa-col divisa-col-12 divisa-col-md-9">
      <div class="divisa-row my-1">
        <div class="divisa-col divisa-col-6 divisa-col-md-4 mt-2 mt-md-0">
          <span class="reservacion-label">{{
            'RESERVATION_CONFIRMATION.PAY_TITLE' | translate
          }}</span>
          <div class="divisa-row my-1">
            <img class="reservacion-img-flag" [src]="reservacion.transaction[0].idCurrencyPayment.iconPath" alt="">
            <span class="reservacion-moneda">{{ reservacion.transaction[0].idCurrencyPayment.name }}</span>
            <span class="reservacion-cantidad">{{ reservacion.transaction[0].amountPayment | currency }}</span>
          </div>
        </div>
        <div class="divisa-col divisa-col-6 divisa-col-md-4 mt-2 mt-md-0">
          <span class="reservacion-label">{{
            'RESERVATION_CONFIRMATION.RECEIVE_TITLE' | translate
          }}</span>
          <div class="divisa-row my-1">
            <img class="reservacion-img-flag" [src]="reservacion.transaction[0].idCurrencyReceives.iconPath" alt="">
            <span class="reservacion-moneda">{{ reservacion.transaction[0].idCurrencyReceives.name }}</span>
            <span class="reservacion-cantidad">{{ reservacion.transaction[0].amountReceives | currency }}</span>

          </div>
        </div>
        <div class="divisa-col divisa-col-12 divisa-col-md-4 mt-2 mt-md-0">
          <span class="reservacion-label">{{
            'RESERVATIONS_LIST.POINTS_LABEL_WILL_EARN' | translate
          }}</span>
          <div class="divisa-row my-1">
            <img class="reservacion-img-flag" src="./assets/icons/icon-128x128.png" alt="">
            <span class="reservacion-cantidad"
              >{{ reservacion.quotation?.calculatedPoints ?? 0 }}
              {{ 'RESERVATIONS_LIST.POINTS_CAPITAL_SUFFIX' | translate }}</span
            >
          </div>
        </div>
      </div>
      <div class="divisa-row my-1">
        <div class="divisa-info-card mt-2 mt-md-0">
          <img class="reservacion-img-span" src="./assets/icons/icon-128x128.png" alt="">
          <span class="text-span">{{ reservacion.idBranch.branchName }}</span>
        </div>
        <div class="divisa-info-card mt-2 mt-md-0">
          <img class="reservacion-img-span" src="./assets/img/clock.svg" alt="">
          <span class="text-span">{{
            'SHARED.DUE_AT'
              | translate
                : {
                    datetime:
                      (reservacion.createdAt | date : 'HH:mm dd/MM/yyyy')
                  }
          }}</span>
        </div>
      </div>
    </div>
    <div class="divisa-col divisa-col-12 divisa-col-md-3 pt-3 pt-md-0">
      <button class="btn btn-primary" [routerLink]="[reservacion.id]">{{
        'RESERVATIONS_LIST.VIEW_DETAILS' | translate
      }}</button>
    </div>
  </div>

</div>
